export const positions = [
	[
		{ column: 3, row: 1 },
	],
	[
		{ column: 2, row: 1 },
		{ column: 4, row: 1 },
	],
	[
		{ column: 1, row: 2 },
		{ column: 3, row: 1 },
		{ column: 5, row: 2 },
	],
	[
		{ column: 1, row: 2 },
		{ column: 2, row: 1 },
		{ column: 4, row: 1 },
		{ column: 5, row: 2 },
	],
	[
		{ column: 1, row: 2 },
		{ column: 2, row: 1 },
		{ column: 3, row: 1 },
		{ column: 4, row: 1 },
		{ column: 5, row: 2 },
	],
	[
		{ column: 1, row: 2 },
		{ column: 1, row: 1 },
		{ column: 2, row: 1 },
		{ column: 4, row: 1 },
		{ column: 5, row: 1 },
		{ column: 5, row: 2 },
	],
	[
		{ column: 1, row: 2 },
		{ column: 1, row: 1 },
		{ column: 2, row: 1 },
		{ column: 3, row: 1 },
		{ column: 4, row: 1 },
		{ column: 5, row: 1 },
		{ column: 5, row: 2 },
	],
	[
		{ column: 1, row: 3 },
		{ column: 1, row: 2 },
		{ column: 1, row: 1 },
		{ column: 2, row: 1 },
		{ column: 3, row: 1 },
		{ column: 4, row: 1 },
		{ column: 5, row: 1 },
		{ column: 5, row: 2 },
	],
	[
		{ column: 1, row: 3 },
		{ column: 1, row: 2 },
		{ column: 1, row: 1 },
		{ column: 2, row: 1 },
		{ column: 3, row: 1 },
		{ column: 4, row: 1 },
		{ column: 5, row: 1 },
		{ column: 5, row: 2 },
		{ column: 5, row: 3 },
	],
	// spectator mode
	[
		{ column: 3, row: 3 },
		{ column: 1, row: 3 },
		{ column: 1, row: 2 },
		{ column: 1, row: 1 },
		{ column: 2, row: 1 },
		{ column: 3, row: 1 },
		{ column: 4, row: 1 },
		{ column: 5, row: 1 },
		{ column: 5, row: 2 },
		{ column: 5, row: 3 },
	],
];